import {
  CloseOutlined
} from "@ant-design/icons";
import { Print } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import usePopUpAtOnce from "components/hooks/usePopUpAtOnce";
import Loading from "components/Loading";
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import { useMobileDetect, useTabletDetection } from "containers/chat/hooks";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { useSentenceView } from "store/main_book_popup/selectors";
import { updateUI } from "store/UI/actions";
import styled from "styled-components";
import { default as COLOR, default as color } from "utils/constants/color";

const Wrapper = styled.div`
  position: absolute;
  top: ${(p) => p.pathname?.includes("ebook") ? "40px" : "0px" };
  width: ${(p) => p.width}px;
  height: ${(p) => p.height}px;
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: 7px -3px 26px 20px rgb(66 66 66),
    -4px -3px 26px 15px rgb(95 109 110);
  z-index: 111;
`;
const Images = styled.img`
  background-color: ${COLOR.white};
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
  object-fit: fill;
  height: 97%;
  width: 100%;
  @media print {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }
`;
export default function SentenceStarterBookPopUp({ getRef }) {
  const showAlert = useAlert();
  const { sentenceView, revokeSentenceView } = useSentenceView();
  const [pages, setPages] = useState("");
  const containerRef = getRef();
  const [style, setStyle] = useState({ height: 0, width: 0 });
  const backBtnRef = useRef();
  const forwardBtnRef = useRef();
  const imageRef = useRef();
  const [printLoader, setPrintloader] = useState(false);
  const isTablate = useTabletDetection();
  const isMobile = useMobileDetect() && !isTablate;
  const {updatePopUpAtOnce} = usePopUpAtOnce();
  const location = useLocation();

  useEffect(() => {
    if (sentenceView?.pages?.view === "english" && sentenceView.open) {
      setPages(sentenceView?.pages?.englishImageUrl);
    } else if (sentenceView?.pages?.view === "spanish" && sentenceView.open) {
      setPages(sentenceView?.pages?.url);
    }else{
      setPages("");
    }
  }, [sentenceView]);

  useEffect(() => {
    function updateStyle() {
      if (containerRef) {
        const { width, height } = containerRef.getBoundingClientRect();
        setStyle({ height, width });
      }
    }

    updateStyle();
    window.addEventListener("resize", updateStyle);

    return () => {
      window.removeEventListener("resize", updateStyle);
    };
  }, [sentenceView]);
  useEffect(() => {
    document.addEventListener("keydown", checkKey);
    return () => {
      document.removeEventListener("keydown", () => {});
    };
  }, []);
  const handleClose = () => {
    revokeSentenceView();
    updatePopUpAtOnce(false);
  };
  function checkKey(e) {
    let isMainBook =
      document.getElementsByClassName("main-book-popup printScreenPage")
        .length > 0;
    if (isMainBook) {
      e = e || window.event;
      if (e.keyCode == "37") {
        if (backBtnRef.current && !backBtnRef.current.disabled) {
          backBtnRef.current.click();
        }
      } else if (e.keyCode == "39") {
        if (forwardBtnRef.current && !forwardBtnRef.current.disabled) {
          forwardBtnRef.current.click();
        }
      }
    }
  }
  const getPgSrc = () => {
    if (pages) {
      return pages;
    }
  };
  const validationPrint = useReactToPrint({
    contentRef: imageRef,
    onBeforeGetContent: async () => {
      setPrintloader(true);
    },
    onBeforePrint: async () => {
      setPrintloader(false);
    },
    onAfterPrint: async () => {
      setPrintloader(false);
    },
  });

  const printFuc = () => {
    if (isMobile || isTablate) {
      showAlert("Print is not supported on this device!", "error");
      return;
    } else {
      validationPrint();
    }
  };

  if (!sentenceView.open) return null;

  return (
    <Wrapper
      width={style.width}
      height={style.height + 36}
      className={sentenceView.open ? "main-book-popup printScreenPage sentenceViewPopup" : ""}
      pathname={location.pathname}
    >
      <CloseOutlined
        onClick={handleClose}
        style={{
          position: "absolute",
          top: "-10px",
          right: "-10px",
          cursor: "pointer",
          fontSize: "16px",
          color: "white",
          background: "red",
          padding: "5px",
          borderRadius: "50%",
        }}
      />
      <IconButton
        onClick={printFuc}
        aria-label="print"
        disabled={printLoader}
        style={{
          position: "absolute",
          top: "-13px",
          right: "20px",
          cursor: "pointer",
          fontSize: "16px",
          color: "white",
          background: color.green100,
          padding: "5px",
          borderRadius: "50%",
        }}
      >
        {printLoader ? <Loading size={20} white /> : <Print />}
      </IconButton>
      <div className="printable" ref={imageRef}>
        <Images src={getPgSrc()} />
      </div>
    </Wrapper>
  );
}

const PaddedBtn = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  outline: none;
  padding: 8px;
  text-align: left;
  width: 100%;
`;